import type { GridFilterOperator } from '@zoryn/components/grid'
import type { FilterPayloadNode } from '@zoryn/components/grid'
export type RuleColumnType =
  | 'input'
  | 'number'
  | 'date'
  | 'lov'
  | 'table'
  | 'switch'

export type RulesType = 'system' | 'user'

/** @deprecated 使用 RulesType */
export type RulesManagerType = RulesType

/** 规则结果内容类型：system 可选 error | boolean | result；user 仅 boolean | result */
export type RuleContentType = 'error' | 'boolean' | 'result'

export type RuleUserContentType = 'boolean' | 'result'

/** @deprecated 使用 RuleContentType */
export type RuleResultType = RuleContentType

/** resultJson 中业务结果值的固定 key */
export const RULE_RESULT_VALUE_KEY = 'value'

/** resultJson 中错误消息的固定 key */
export const RULE_ERROR_MESSAGE_KEY = 'message'
export interface SystemParamField {
  system?: string
  module?: string
  /** 参数字段 key */
  field: string
  /** 参数名称（展示用） */
  name: string
  /** 列类型：输入框 | 值类型 | 表格 | 复选框 或英文 type */
  columnType: string
  /** LOV 类型或 table 的 module 路径 */
  dataSource?: string
}

export interface RuleCondition {
  id: string
  field: string
  operator: GridFilterOperator
  type: RuleColumnType
  value: unknown
  operatorList: Array<{ value: GridFilterOperator; label: string }>
  logic: string
  dataSource?: string
  /** table/lov 展示用文案，写入 rulesJson 供描述还原，不参与 Aviator 运算 */
  valueLabel?: string
}

export interface RuleGroupState {
  id: string
  logic: 'and' | 'or'
  groupLogic: 'and' | 'or'
  conditions: RuleCondition[]
}

/** content="result" 时由程序员定义的结果区 schema */
export interface RuleResultSchema {
  label: string
  type: RuleColumnType
  dataSource?: string
  required?: boolean
  defaultValue?: unknown
}

export type RuleResultValue = Record<string, unknown>

/** 规则表行记录（保存到后端 / LiteFlow） */
export interface RuleRecord {
  id: string
  system: string
  module?: string
  ruleName: string
  ruleDescription: string
  rulesJson: FilterPayloadNode | FilterPayloadNode[] | null
  resultJson: RuleResultValue
  /** 规则结果内容类型 */
  content?: RuleContentType
  ruleScript: string
  ruleExpr: string
  scriptLanguage: 'aviator'
  enabled: boolean
  priority?: number
}
